import { Document, Page, StyleSheet, Font, Text, View } from '@react-pdf/renderer';
import type { IbanTransfer } from 'types/Iban';

Font.register({
  family: 'Source Sans Pro', fonts: [
    { src: 'https://fonts.gstatic.com/s/sourcesanspro/v14/6xK3dSBYKcSV-LCoeQqfX1RYOo3aPw.ttf' }, // font-style: normal, font-weight: normal
    { src: 'https://fonts.gstatic.com/s/sourcesanspro/v14/6xKydSBYKcSV-LCoeQqfX1RYOo3i54rAkA.ttf', fontWeight: 600 },
  ]
});

const stylesPdf = StyleSheet.create({
  page: {
    padding: '64',
  },
  grid: {
    backgroundColor: 'rgba(227,227,227,0.5)',
    borderRadius: '5',
    padding: '4 16',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: '16',
    marginTop: '0',
    fontFamily: 'Source Sans Pro',
  },
  pageTitle: {
    fontSize: '16',
    textAlign: 'center',
    fontFamily: 'Source Sans Pro',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: '#656565',
  },
  text: {
    width: '64%',
    margin: '8px 0',
    fontWeight: 500,
    fontSize: '14',
    fontFamily: 'Source Sans Pro',
  },
  title: {
    width: '35%',
    margin: '8px 0',
    fontWeight: 500,
    color: '#656565',
    fontSize: '14',
    fontFamily: 'Source Sans Pro',
  },
  hint: {
    fontSize: '12',
    fontFamily: 'Source Sans Pro',
    marginBottom: '24'
  },
  holderTitle: {
    marginTop: '0',
    color: '#656565',
    fontFamily: 'Source Sans Pro',
    fontSize: '14'
  },
  holderText: {
    marginTop: '4',
    fontSize: '14',
    fontFamily: 'Source Sans Pro',
  },
  logo: {
    fontWeight: 700,
    fontFamily: 'Source Sans Pro',
    fontSize: '14',
    textAlign: 'center',
    marginBottom: '24',
  }
});

const IbanPDF = ({ transfer, t }: {
  transfer: IbanTransfer,
  t: (key: string, options?: Record<string, any>) => string;
}) => (
  <Document>
    <Page style={stylesPdf.page}>
      <View>
        <Text style={stylesPdf.pageTitle}>
          {t('payment.transfert.longTitle')}
        </Text>
        <Text style={stylesPdf.logo}>
          {transfer.display_bank_transfer_instructions.financial_addresses[0].iban.account_holder_name}
        </Text>
        <Text style={stylesPdf.hint}>
          {t('payment.transfert.description')}
        </Text>
      </View>
      <View style={stylesPdf.grid}>
        <Text style={stylesPdf.title}>
          {t('payment.transfert.amount')} :
        </Text>
        <Text style={stylesPdf.text}>
          {`${transfer.display_bank_transfer_instructions.amount_remaining} ${transfer.display_bank_transfer_instructions.currency === 'eur' ? '€' : transfer.display_bank_transfer_instructions.currency}`}
        </Text>
        <Text style={stylesPdf.title}>
          {t('payment.transfert.bank')} :
        </Text>
        <Text style={stylesPdf.text}>
          {transfer.display_bank_transfer_instructions.financial_addresses[0].iban.account_holder_name}
        </Text>
        <Text style={stylesPdf.title}>
          {t('payment.transfert.iban')} :
        </Text>
        <Text style={stylesPdf.text}>
          {transfer.display_bank_transfer_instructions.financial_addresses[0].iban.iban.match(/.{1,4}/g)?.join('  ')}
        </Text>
        <Text style={stylesPdf.title}>
          {t('payment.transfert.bic')} :
        </Text>
        <Text style={stylesPdf.text}>
          {transfer.display_bank_transfer_instructions.financial_addresses[0].iban.bic}
        </Text>
      </View>
    </Page>
  </Document>
);

export default IbanPDF;
